import Snackbar from '@web-ui-kit/snackbar'
import PropTypes from 'prop-types'

import * as Sc from './SnackBarFeedback.style'
import useMediaQuery from 'hooks/useMediaQuery'

const SnackBarFeedback = ({ dataTestId, id, text, variant }) => {
  const { isMobile } = useMediaQuery()
  return (
    <Sc.Container>
      <Snackbar
        dataTestId={dataTestId}
        id={id}
        size={isMobile ? 'small' : 'large'}
        text={text}
        type={variant}
      />
    </Sc.Container>
  )
}

SnackBarFeedback.defaultProps = {
  dataTestId: null,
}

SnackBarFeedback.propTypes = {
  dataTestId: PropTypes.string,
  id: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  variant: PropTypes.string.isRequired,
}

export default SnackBarFeedback
